import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";
import { S } from "../../data/strings";
import { MUKUT, waLink, WA } from "../../data/content";
import { SectionHead } from "./Ornament";
import { WhatsappIcon } from "./Header";
import { EASE } from "../../lib/motion";

export const MukutShringar = () => {
  const { t } = useLang();
  return (
    <section id="mukut" data-testid="mukut-section" className="relative bg-burgundy grain py-24 sm:py-32 overflow-hidden">
      {/* jaali watermark */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, #D4AF37 1px, transparent 0)",
          backgroundSize: "24px 24px",
        }}
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-[1400px] px-6 sm:px-10">
        <SectionHead overline={S.mukut.overline} heading={S.mukut.heading} sub={S.mukut.sub} dark />

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-5 sm:gap-7 max-w-5xl mx-auto">
          {MUKUT.map((p, i) => (
            <motion.article
              key={p.name.en}
              data-testid={`mukut-card-${i}`}
              className="group relative"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.7, ease: EASE, delay: (i % 4) * 0.08 }}
            >
              <div className="relative overflow-hidden rounded-lg border border-gold/25 aspect-square bg-velvet">
                <img
                  src={p.img}
                  alt={`${t(p.name)} — royal shringar for the deity`}
                  loading="lazy"
                  className="w-full h-full object-cover transition-all duration-[1200ms] ease-out group-hover:scale-110"
                />
                {/* spotlight */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 bg-[radial-gradient(circle_at_50%_40%,rgba(243,222,144,0.25),transparent_60%)]" />
              </div>
              <div className="mt-4">
                <h3 className="font-serif text-base sm:text-lg text-ivory leading-tight">{t(p.name)}</h3>
              </div>
              <a
                href={waLink(WA.mukut(p.name.en))}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`mukut-enquire-${i}`}
                className="mt-2 inline-flex items-center gap-1.5 font-cinzel text-[10px] tracking-widest uppercase text-gold hover:text-goldlight transition-colors"
              >
                <WhatsappIcon className="w-3 h-3" /> {t(S.enquireWa)}
              </a>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
